import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
import { Offer } from "../Companies";
import { Customer } from "../Customers";
import { Order } from "../Orders";
import { TagPosition } from "../Store/TagPosition";
/**
 * Product base class
 */

export class ProductBase extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getId = () => {
      return this.model.id;
    };

    this.getOfferId = () => {
      return this.model.offerId;
    };

    this.getEpcId = () => {
      return this.model.epcId;
    };

    this.getSerialNumber = () => {
      return this.model.serialNumber;
    };

    this.isInHall = () => {
      return Boolean(this.model.inHall);
    };

    this.getCreatedAt = () => {
      return this.model.createdAt;
    };

    this.getIsVisible = () => {
      return Boolean(this.model.isVisible);
    };

    this.getIsDefective = () => {
      return Boolean(this.model.isDefective);
    };

    this.getOffer = offer => {
      return this.getRelation('offer', Offer, offer);
    };

    this.getOrder = order => {
      return this.getRelation('order', Order, order);
    };

    this.getTagPosition = tagPosition => {
      return this.getRelation('tagPosition', TagPosition, tagPosition);
    };

    this.getCustomer = customer => {
      return this.getRelation('customer', Customer, customer);
    };
  }

  /**
   * Create product base
   *
   * @param {object} object
   *
   * @return {ProductBase}
   */
  static create(object) {
    return super.create(object);
  }
  /**
   * Create list product base
   *
   * @param {object} objects
   *
   * @return {Array.<ProductBase>}
   */


  static createList(objects) {
    return super.createList(objects);
  }
  /**
   * Map product base
   *
   * @param {Array.<object>} objects
   * @param {function(ProductBase): undefined} callback
   *
   * @return {Array.<object>}
   */


  static map(objects, callback) {
    return super.map(objects, callback);
  }
  /**
   * Get id
   *
   * @return {number}
   */


}